import { ComponentKey } from 'enums/componentKey';
import { InputRenderersFor, RowInputRenderersFor, translateItems } from 'factories/input-factory/types';
import { FormikSelectCardContainer } from 'features/referentials/components/FormikSelectCardContainer';
import { ReferentialDropdown } from 'features/referentials/components/ReferentialDropdown';
import { ReferentialTagInput } from 'features/referentials/components/ReferentialTagInput';

/* The renderers the referentials feature CONTRIBUTES to the factory registry
   (assembled at the composition root, src/index.tsx): the core never imports
   them. */
export const referentialRenderers: InputRenderersFor<
  | ComponentKey.ReferentialDropdown
  | ComponentKey.ReferentialTagInput
  | ComponentKey.SelectCard
> = {
  [ComponentKey.ReferentialDropdown]: (cfg, base) => (
    <ReferentialDropdown
      {...base}
      referentialKey={cfg.referentialKey}
      omitKeys={cfg.omitKeys}
    />
  ),

  [ComponentKey.ReferentialTagInput]: (cfg, base) => (
    <ReferentialTagInput
      {...base}
      referentialKey={cfg.referentialKey}
      omitKeys={cfg.omitKeys}
      maxTags={cfg.maxTags}
    />
  ),

  [ComponentKey.SelectCard]: (cfg, base, { t }) => (
    <FormikSelectCardContainer
      referentialKey={cfg.referentialKey}
      name={base.name}
      items={translateItems(cfg.items, t)}
      label={base.label}
      required={base.required}
      disabled={base.disabled}
      isMultiple={cfg.isMultiple}
      disableKeys={cfg.disabledKeys}
      requireSelection={cfg.requireSelection}
      maxSelections={cfg.maxSelections}
      className={cfg.className}
    />
  ),
};

/* DynamicArray row sub-fields (controlled contract: value + onChange through
   arrayHelpers, no Formik binding by name). */
export const referentialRowRenderers: RowInputRenderersFor<ComponentKey.ReferentialDropdown> = {
  [ComponentKey.ReferentialDropdown]: (field, { value, onChange, label, required }) => (
    <ReferentialDropdown
      name={field.name}
      label={label}
      required={required}
      placeholder={field.placeholder}
      referentialKey={field.referentialKey}
      selectedItemKey={value}
      onChange={(selectedItem) => onChange(selectedItem?.key || null)}
    />
  ),
};
